import {apiStore} from "@/stores/api";
import {crossbarStore} from "@/stores/crossbar";
import {demobedStore} from "@/stores/demobed";
import {measurementStore} from "@/stores/measurement";
import {socketStore} from "@/stores/socket";

export default {
    created: function() {
        if (this.loggedInSales) {
            this.connectToSocket();
        }
    },

    computed: {
        loggedInUser() {
            return apiStore().loggedInUser;
        },

        loggedInSales() {
            return apiStore().loggedInSales;
        },

        isUserLoggedIn() {
            return this.loggedInUser !== null && this.loggedInUser !== undefined;
        },

        isSalesLoggedIn() {
            return apiStore().isSalesLoggedIn;
        },

        isAdmin() {
            return this.isUserLoggedIn && this.loggedInUser.role === "admin";
        },

        isSales() {
            return this.isUserLoggedIn && this.loggedInSales.role === "sales";
        },

        isSalesAdmin() {
            return this.isSalesLoggedIn && this.loggedInSales.is_admin === true;
        }
    },

    methods: {
        connectToSocket() {
            socketStore().connect();

            measurementStore().shopId = this.loggedInSales.shop_id;
            demobedStore().shopId = this.loggedInSales.shop_id;
            crossbarStore().connect();
        }
    }
};
